var $ = require('jquery'),
    Util = require('../util'); /* just for isIE in unselectable */


$.fn.ajaxErrorMessage = function( jqXHR ) {
    return jqXHR.status + ' ' + jqXHR.statusText + ': ' + jqXHR.responseText;
};

/* Note: like with scrollbar plugin, append to html, not body, in case not yet loaded */
$.fn.getDPI = function () {
    var $inchDiv = $('<div class="inch" style="width: 1in;"></div>').appendTo($('html')),
        px = $inchDiv.width();
    $inchDiv.remove();
    return px;
};


$.fn.getHiddenElementDimensions = function(options) {

    var defaults = {
        $container: $('body'),
        removeClass: 'hide', /* note: could be list, space delimited */
        addClass: 'offScreen',
        useOuter: true
    },
    s = $.extend({}, defaults, options),
    $clone = this.clone()
        .removeClass(s.removeClass)
        .addClass(s.addClass)
        .appendTo(s.$container);

    if (options && options.removeInlineDimensions) {
        $clone.css({
            height: '',
            width: ''
        });
    }

    var w = $clone[s.useOuter ? 'outerWidth' : 'width'](),
        h = $clone[s.useOuter ? 'outerHeight' : 'height']();

    $clone.remove();

    return {
        width: w,
        height: h
    };
};

$.fn.getMouseCoordinate = function (event) {
    return {x: event.pageX, y: event.pageY};
};

$.fn.setCursorEndOfText = function () {
    var origVal = this.val();
    this.focus().val('').val(origVal); //this deletes the txt
    return this;
};

/* keep the element in view of a container if scrollPos changes
 - assumes the container element dimensions can change
 */

$.fn.keepInView = function ($container, initPos) {
    //todo: think out and fix
    var $el = this,
        fnOriginalPosition = function () {
            $el.css({
                position: 'absolute',
                top: initPos.y,
                left: initPos.x
            });
        };

    fnOriginalPosition(); //the default is to set to initPos -- positioned absolutely on screen
    return this;
};


/* When Iframes Are Moved in the DOM they Reload -- run this b/f to put the contents in post move */
$.fn.persistIframeChildrenOnMove = function () {
    var $el = this;
    $el.find('iframe').each(function (i, el) {

        var $f = $(el),
         iframeDocument = $f[0].contentWindow.document;
         markup = $f.getMarkupOfIframe();

        /* Store the html markup on data element of the iframe, when it loads, set the html of the iframe to the markup */
        $f.one('load', function () { //load triggered post DOM move
            iframeDocument.write( markup ); //put back before append
            iframeDocument.close();
        });

    });
    return this;
};


//Note: DVBC-955 - $.contents BREAKS if invalid markup ( really .contentDocument ) -- eg with Adobe PDF plugin, now not all in HTML tag (the PDF is in an object tag outside
$.fn.getMarkupOfIframe = function() {
    var iframeDocument = this[0].contentWindow.document,
        iframeElements = iframeDocument.getElementsByTagName('*'),
        curElement = iframeElements[0],
        markup = '';
    while (curElement !== null) {
        markup += curElement.outerHTML;
        curElement = curElement.nextSibling;
    }
    return markup;
};


/* Return whether or not the cursor is position over element with given selector*/
$.fn.isMouseOver = function (uniqueSelector) {
    return $(uniqueSelector + ':hover').length > 0;
};

/* Takes el and all ancestors but input and select and make unselectable */
$.fn.unselectable = function() {
    var $els = this.add(this.find('*').not('input, select'));
    Util.isIE() //todo: rid dependency
        ? $els.attr('unselectable', 'on') //IE<10
        : $els.addClass('unselectable'); //(less mixin)
    return this;
};

/* cross browser selection of the text in an element */
$.fn.selectAll = function() {
    var doc = document,
        range,
        selection;
    if (doc.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(this[0]);
        range.select();
    } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(this[0]);
        selection.removeAllRanges();
        selection.addRange(range);
    }
    return this;
};


/* Check the style attribute of an elem for a cssProperty, if it exists, return the value, otherwise return null */
$.fn.getInlineStyle = function(cssProp) {
    var styleAttr = this.attr('style');
    if (!styleAttr) return null;
    var cssProperties = styleAttr.split(';');
    for (var i=0; i<cssProperties.length; i++) {
        var style = cssProperties[i].split(':'),
            prop = $.trim(style[0]),
            val = $.trim(style[1]);
        if (cssProp === prop) {
            return val;
        }
    }
    return null;
};

/* used in inView and lazyLoad plugins -- note: assuming element isn't window */
$.fn.getOffsets = function() {
    var $this = this,
        offset = this.offset();
    return {
        top: offset.top,
        height: $this.height(),
        left: offset.left,
        width: $this.width()
    };
};

/*
* Returns a string of wrapped text to fit a given width, fontSize, & fontFamily
* */
$.fn.textWrap = function(txt, width, fontSize, fontFamily, $container, padding) {

    var $spacer = $('<span class="spacer"></span>').appendTo($container).css({
            'font-size': fontSize,
            'font-family': fontFamily,
            visibility: 'hidden',
            padding: padding ? padding : 0 //not worrying about now
        }),
        spaceWt = $spacer.html('&nbsp').width(),
        wrTxt = '',
        words = txt.split(' '),
        nWords = words.length,
        curLineWt = 0,
        curWordWt = 0,
        curWord;

    for (var i = 0; i < nWords; i++) {
        curWord = words[i];
        curWordWt = $spacer.text(curWord).width();
        if (curLineWt + spaceWt + curWordWt >= width) {
            wrTxt = wrTxt + '\n' + curWord;
            curLineWt = curWordWt;
        } else {
            wrTxt = (i === 0) ? curWord : wrTxt + ' ' + curWord;
            curLineWt = curLineWt + curWordWt + spaceWt;
        }
    }
    $spacer.remove();
    return wrTxt;

};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/extension/jquery.js
 ** module id = 76
 ** module chunks = 0
 **/